import React from 'react';

import {Route, BrowserRouter, Redirect, Switch} from 'react-router-dom';
import AppRoute from './components/layouts/Layout';
import DashboardLayout from './components/layouts/DashboardLayout';
import AuthLayout from './components/layouts/AuthLayout';

import Home from './components/pages/dashboard/Home';
import TalentSearch from './components/pages/dashboard/TalentSearch';
import ComparePlayers from './components/pages/dashboard/talent_search/ComparePlayers';
import SidebarFilter from './components/pages/dashboard/talent_search/SidebarFilter';
import Watchlist from './components/pages/dashboard/watchlist/Watchlist';
import Messages from './components/pages/dashboard/Messages';

import Scouting from './components/pages/dashboard/scouting/Scouting'
import PlayerEvaluation from './components/pages/dashboard/player_evaluation/PlayerEvaluation'
import EvaluationReport from './components/pages/dashboard/evaluation_report/EvaluationReport'

import SignIn from './components/pages/auth/SignIn';
import SignUp from './components/pages/auth/SignUp';
import ForgotPassword from './components/pages/auth/ForgotPassword';
import ResetPassword from './components/pages/auth/ResetPassword';

import Payment from './components/pages/payment/Payment';

import FullProfile from "./components/pages/dashboard/FullProfile";
import OtherPlayers from "./components/ui/asides/OtherPlayers";
import MatchesAndEvents from "./components/pages/dashboard/MatchesAndEvents";
import OtherTeams from "./components/ui/asides/OtherTeams";
import MatchAndEventMatchReport from "./components/pages/dashboard/MatchAndEventMatchReport";
import Error from "./components/pages/dashboard/Error";

import ProfileSettings from './components/pages/dashboard/profile_settings/ProfileSettings';

import LandingLayout from './components/layouts/LandingLayout';
import Landing from './components/pages/landing/home/Landing';
import Pricing from './components/pages/landing/pricing/Pricing';
import Contact from './components/pages/landing/contact/Contact';

const PaymentLayout = (props) => <AuthLayout colProps={{ lg: 7 }} {...props} />

function App() {
    return (
        <BrowserRouter>
            <Switch>
                {/* landing page */}
                <AppRoute exact path="/" layout={LandingLayout} component={Landing} title="Landing Page"/>
                <AppRoute exact path="/pricing" layout={LandingLayout} component={Pricing} title="Pricing Page"/>
                <AppRoute exact path="/contact" layout={LandingLayout} component={Contact} title="Contact Page"/>

                {/* dashboard */}
                {/*redirect / to dashboard page */}
                {/* <Route exact path="/" render={() => (<Redirect to="/dashboard"/>)}/> */}
                <AppRoute path="/dashboard" layout={DashboardLayout} component={Home} title="Dashboard"/>
                <AppRoute exact path="/talent-search" layout={DashboardLayout} component={TalentSearch} title="Talent Search" aside={SidebarFilter}/>
                {/* page: ['talent-search', 'watchlist'] */}
                <AppRoute exact path="/:page/compare-players" layout={DashboardLayout} component={ComparePlayers} title="Compare Players" header="detail"/>
                {/* page: ['talent-search', 'watchlist', 'scouting'] */}
                <AppRoute exact path="/:page/full-profile/:id" layout={DashboardLayout} component={FullProfile} aside={OtherPlayers} title="Full Profile" back_unique="talent-search" header="detail"/>

                <AppRoute exact path="/matches-and-events" layout={DashboardLayout} component={MatchesAndEvents} aside={OtherTeams} title="Matches and Events" front_unique="matches-and-events"/>
                <AppRoute exact path="/matches-and-events/report/:id" layout={DashboardLayout} component={MatchAndEventMatchReport} title="Full Match Stats And Videos" front_unique="match-and-event-match-report" back_unique="matches-and-events" header="detail"/>

                <AppRoute exact path="/watchlist" layout={DashboardLayout} component={Watchlist} title="Watchlist"/>

                <AppRoute exact path="/scouting" layout={DashboardLayout} component={Scouting} title="Scouting"/>

                {/* page: ['scouting', 'my-scouting'] */}
                <AppRoute exact path="/:page/player-evaluation/:playerId?" layout={DashboardLayout} component={PlayerEvaluation} title="Player Evaluation" back_unique="player-evaluation" header="detail"/>
                {/* page: ['scouting', 'my-scouting'] */}
                <AppRoute exact path="/:page/evaluation-report/:playerId?" layout={DashboardLayout} component={EvaluationReport} title="Evaluation Report" back_unique="evaluation-report" header="detail"/>

                <AppRoute path="/messages" layout={DashboardLayout} component={Messages} title="Messages"/>

                <AppRoute exact path="/profile-settings" layout={DashboardLayout} component={ProfileSettings} title="Profile Settings"/>


                {/* auth */}
                <AppRoute path="/signin" layout={AuthLayout} component={SignIn}/>
                <AppRoute path="/signup" layout={AuthLayout} component={SignUp}/>
                <AppRoute path="/forgot-password" layout={AuthLayout} component={ForgotPassword}/>
                <AppRoute path="/reset-password" layout={AuthLayout} component={ResetPassword}/>
                <AppRoute path="/payment" layout={PaymentLayout} component={Payment} title="Payment Page" />

                <AppRoute path="*" layout={DashboardLayout} component={Error} title="Error"/>
            </Switch>
        </BrowserRouter>
    );
}

export default App;
